import { useState } from 'react';

import { SelectProps as MuiSelectProps } from '@mui/material/Select';
import Fade from '@mui/material/Fade';

import ArrowDownIcon from 'shared/icons/ArrowDown';

import {
  StyledSelect,
  StyledIconButton,
  StyledMenuItem,
  StyledAdornment,
  CustomVariant,
} from './Select.style';

type SelectProps<T extends string | number> = {
  options: T[];
  getOptionLabel?: (option: T) => string;
  variant?: CustomVariant;
} & Pick<
  MuiSelectProps<T>,
  'value' | 'name' | 'disabled' | 'onChange' | 'sx' | 'placeholder'
>;

function Select<T extends string | number>(props: SelectProps<T>) {
  const { options, onChange, getOptionLabel, variant, ...rest } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <StyledSelect
      {...rest}
      /* @ts-ignore */
      onChange={onChange}
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      disableUnderline
      variant="standard"
      customVariant={variant}
      endAdornment={
        <StyledAdornment position="end" onClick={handleOpen}>
          <StyledIconButton active={isOpen} customVariant={variant}>
            <ArrowDownIcon sx={{ fontSize: '19px' }} />
          </StyledIconButton>
        </StyledAdornment>
      }
      IconComponent={() => null}
      MenuProps={{
        disablePortal: true,
        PaperProps: {
          sx: {
            maxHeight: '250px',
            background: '#f9f9f9',
            borderRadius: 0,
          },
        },
        TransitionComponent: Fade,
      }}
    >
      {options.map((option, index) => (
        <StyledMenuItem key={index} value={option}>
          {getOptionLabel ? getOptionLabel(option) : option}
        </StyledMenuItem>
      ))}
    </StyledSelect>
  );
}

export type { SelectChangeEvent } from '@mui/material/Select';
export default Select;
